import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { get2 } from "../axios";
import { Menu } from "../v2/queries/interfacesV2";
import useBranchId from "./useBranchId";

function useCategoryQuery<TData = Menu>(
  deliveryMethod = "1",
  select?: (data: Menu) => TData
) {
  const branch = useBranchId();
  const language = 0;
  const url = `external/anonymous/websites/v3/menus/complete/${branch}/${deliveryMethod}/${language}`;
  const queryKey = ["category", deliveryMethod, branch];
  const query = useQuery<Menu>({
    queryKey: queryKey,
    queryFn: () => get2(url),
    // the menu is large; avoid refetching + re-rendering it on every kiosk page change
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // @ts-ignore
    select,
  })as UseQueryResult<TData, Error>;;

  return query;
}

export default useCategoryQuery;
